import * as angular from 'angular';
import { IUtilities } from '../../typings/services';
import { ClSelectController } from './ClSelectDirective';

/**
 * Simple wrapper for md-option, to help defer compilation of a cl-input-container until all elements are ready to be compiled.
 */

export class ClOptionDirective implements angular.IDirective {
    public static $name: string = 'clOption';

    public restrict: string = 'E';
    public require: string = '^clSelect';

    /* Override ng-repeat priority */
    public priority: number = 1001;

    /* Make sure the attributes do not execute themselves before we copy, pass back to clInputContainer && compile */
    public terminal: boolean = true;

    public link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, clSelectController: ClSelectController) => {
        /* Create new options, copy attributes over & assign text */
        let options = angular.element('<md-option></md-option>');
        this.utilities.copyAllAttributes(options, attrs);
        options.html(element.html());

        /**
         * We need to be able to include multiple cl-option directives under a cl-select to support default values.
         * Therefore, we should do a direct assignment if no options already exist on the controller,
         * or add to the existing ones if they do exist
         */
        clSelectController.options = clSelectController.options ? clSelectController.options.add(options) : options;

        /* Remove the original element, as it is no longer needed */
        element.remove();
    }

    constructor(
        private utilities: IUtilities
    ) {
    }

    public static Factory() {
        let directive = (utilities) => {
            return new ClOptionDirective(utilities);
        };

        directive['$inject'] = ['utilities'];

        return directive;
    }
}
